import { useState } from 'react';
import { sendContactMessage } from '@/services/contact.service';

export function useContact() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const submitContact = async (formData) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      const result = await sendContactMessage(formData);
      setSuccess(result.message || 'Message sent successfully');

      return result;
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Failed to send message');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { submitContact, loading, error, success };
}